import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class FourOhFourDataService {
    constructor(
        private router: Router,
        private location: Location
    ) {}

    redirectTo404(url: string): void {
        this.router.navigate(['404'], {
            skipLocationChange: true
        });
        setTimeout(() => {
            this.location.replaceState(url);
        });
    }

    redirectToDashboard(): void {
        this.router.navigate(['/dashboard']);
    }
}
